import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { RmaResponse } from '@rma/dashboard/generic/util/http';
import { appendToRmaApiUrl } from '@rma/generic/ng/util';
import { Observable } from 'rxjs';
import { ExpressionOfInterestFeatureName, ExpressionOfInterestRequest } from './expression-of-interest.model';

@Injectable({
  providedIn: 'root',
})
export class ExpressionOfInterestService {
  private readonly expressionOfInterestUrl = 'ExpressionOfInterest';

  private readonly httpClient: HttpClient = inject(HttpClient);
  private readonly rmaApiUrl = inject(appendToRmaApiUrl);

  public postExpressionOfInterest(request: ExpressionOfInterestRequest): Observable<RmaResponse> {
    return this.httpClient.post<RmaResponse>(this.rmaApiUrl(this.expressionOfInterestUrl), request);
  }

  public getExpressionOfInterest(featureName: ExpressionOfInterestFeatureName): Observable<RmaResponse> {
    return this.httpClient.get<RmaResponse>(this.rmaApiUrl(`${this.expressionOfInterestUrl}/${featureName}`));
  }
}
